import React from 'react';

import { Col, Row } from 'components/bootstrap';

import SharedCollectionsList from './SharedCollectionsList/SharedCollectionsList';

type Props = {
  userId: string;
};

const UserCollections = ({ userId }: Props) => (
  <Row>
    <Col md={12}>
      <SharedCollectionsList id={userId} filterBy="user" />
    </Col>
  </Row>
);
export default UserCollections;
